import script from "./CustomVueTreeSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomVueTreeSelect.vue?vue&type=script&setup=true&lang=js"

import "./CustomVueTreeSelect.vue?vue&type=style&index=0&id=fc41bd56&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc41bd56"]])

export default __exports__